import ReactGA from 'react-ga4';

let hasInitialized = false;

const useAnalytics = () => {
  const trackCampaignToBackend = (campaign) => {
    const graphqlQuery = {
      operationName: 'MyMutation',
      query: `mutation MyMutation($campaign: String!) { logWebsiteViewed(campaign: $campaign) { success } }`,
      variables: {
        campaign: campaign,
      },
    };

    fetch('https://recyclemore-backend.fly.dev/api/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(graphqlQuery),
    })
    .then(response => response.json())
    .then(data => {
      if (data.data?.logWebsiteViewed?.success) {
        console.log('Successfully logged campaign to backend:', campaign);
      } else {
        console.error('Failed to log campaign to backend:', data.errors || 'Unknown error');
      }
    })
    .catch(error => {
      console.error('Error sending campaign to backend:', error);
    });
  };
  
  const initializeAnalytics = () => {
    if (hasInitialized) {
      return;
    }
    hasInitialized = true;

    ReactGA.initialize('G-M14VNS7LJ1');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search + window.location.hash });

    const searchParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
    
    const campaignSource = searchParams.get('campaign') || hashParams.get('campaign');
    
    if (campaignSource) {
      trackCampaignToBackend(campaignSource);
    }
  };

  const trackEvent = (category, action, label) => {
    if (ReactGA.isInitialized) {
      ReactGA.event({
        category: category,
        action: action,
        label: label,
      });
    }
  };

  return { initializeAnalytics, trackEvent };
};

export default useAnalytics;